export class ChannelHelper {
  public static LAST_CHANNEL_KEY = 'lastChannel';

  public static getSavedChannelId(): number {
    const savedChannel = localStorage.getItem(this.LAST_CHANNEL_KEY);
    if (savedChannel !== null) {
      return Number(savedChannel);
    }
    return 0;
  }

  public static saveLastChannelId(channelId: number): void {
    if (channelId < 1) return;
    localStorage.setItem(this.LAST_CHANNEL_KEY, String(channelId));
  }
}
